import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[view-host]'
})
export class ViewHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
